import "./PlaceHolder.css";

const PlaceHolder = () => {
  return <div className="placeholder" />;
};

export default PlaceHolder;
